import React, { useState } from "react";
import { Row } from "react-bootstrap";
import Image from "./Image.jsx";
import Lightbox from 'react-image-lightbox';
import placeHolder from 'assets/img/image-placeholder.jpg';
import Styles from "./imageGallery.module.css";
import SpproImageAnnote from 'sppro-image-annote';
import RenameFileModal from 'components/RenameFileModal/RenameFileModal';
import uuidv1 from 'uuid/v1';
import './sppro-image-annote.css';
import 'react-image-lightbox/style.css';


function ImageGallery(props) {

    const [photoIndex, setPhotoIndex] = useState(0);
    const [isOpen, setIsOpen] = useState(false);
    const [editImage, setEditImage] = useState();
    const [showRenameModal, setShowRenameModal] = useState(false);
    const [editedImageBase64, setEditedImageBase64] = useState(null);
    const [saveType, setSaveType] = useState("upload"); //Either upload or rename

    const onImageClick = (index) => {
        setPhotoIndex(index);
        setIsOpen(true);
        setEditImage()
    }

    const onEditClick = (index) => {
        document.body.style.overflow = 'hidden';
        setEditImage(props.imageList[index]);
    }

    const onImageAnnoteSave = (base64) => {
        setEditedImageBase64(base64);
        setSaveType("upload");
        setShowRenameModal(true);
    }


    const onRenameSave = (fileName) => {
        fileName = fileName.indexOf('.') === -1 ? `${fileName}.png` : fileName;
        if (saveType === "upload") {
            uploadFile(fileName);
        } else{
            renameFile(fileName);
        }
    }

    const renameFile = (fileName) => {
        props.onRenameFile(props.imageList[photoIndex], fileName, props.sessionId, "rename");
        setShowRenameModal(false);
    }

    const uploadFile = (fileName) => {
        const newFile = {
            id: uuidv1(),
            data: editedImageBase64,
            fileName: fileName,
            progress: 0,
        }

        //First add the preview image that will show the progress
        props.onAddImage(newFile);
        props.onImageUpload(newFile);
        setShowRenameModal(false);
        onEditClose();
    }

    //When edit box closes, set body back to default and hide
    const onEditClose = () => {
        setTimeout(() => document.body.style.overflow = 'inherit', 500);
        setEditImage(null);
    }

    const onRenameClick = (index) => {
        setPhotoIndex(index)
        setSaveType("rename");
        setShowRenameModal(true);
    }
    
    const onAddToReportClick = (index) => {
        let currentFileName = props.imageList[index].fileName;
        let newFileName = `AR_${currentFileName}`;
        if (currentFileName.startsWith("AR_")){
            newFileName = currentFileName.substr(3);
        }
        props.onRenameFile(props.imageList[index], newFileName, props.sessionId, "addToReport");
    }
    
    const renderImages = () => {
        var imageArray = [];
        for (let i = 0; i < props.imageList.length; i++) {
                     
            return props.imageList.map((element, index) => {
                
                //if the source is a link, and not base 64, get the thumbnail version for the tile image
                var source = element.data.indexOf("/api/photo") > -1 ? `${element.data}&thumbnail=true` : element.data;
                return (
                <Image key={element.id}
                    src={source}
                    onBlowImage={() => onImageClick(index)}
                    onEditImage={() => onEditClick(index)}
                    onRename={() => onRenameClick(index)}
                    onAddToReport={() => onAddToReportClick(index)}
                    onSetStreetView={() => props.onSetStreetView(index)}
                    onDelete={() => props.onDeleteFile(index)}
                    streetViewImage={props.streetViewImage}
                    progress={element.progress}
                    uploaded={element.uploaded}
                    fileName={element.fileName}
                    loader={element.loader}
                    />
            )
            })
        }
        return imageArray;
    }

    if (!props.imageList){
        return (
            <div>loading...</div>
        )
    }
    else  return (
        <React.Fragment>
            <Row className={Styles.gallery}>
                {props.imageList.length > 0 ?
                    renderImages() :
                    <Image src={placeHolder} />
                }
            </Row>

            {editImage && <SpproImageAnnote url={editImage.data} onClose={onEditClose} onSave={onImageAnnoteSave} />}
            {isOpen && (
                <Lightbox
                    mainSrc={props.imageList[photoIndex].data}
                    nextSrc={props.imageList[(photoIndex + 1) % props.imageList.length].data}
                    prevSrc={props.imageList[(photoIndex + props.imageList.length - 1) % props.imageList.length].data}
                    onCloseRequest={() => setIsOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + props.imageList.length - 1) % props.imageList.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % props.imageList.length)
                    }
                />
            )}

            <RenameFileModal
                show={showRenameModal}
                onClose={() => setShowRenameModal(false)}
                onSave={onRenameSave}
            ></RenameFileModal>
        </React.Fragment >
    )
}

export default ImageGallery;
